import { ListToolbarRoot } from "./list-toolbar";
import { ListToolbarSearch } from "./parts/search";
import { ListToolbarActions } from "./parts/view-actions";
import { ListToolbarFilters } from "./parts/view-filters";
import { ListToolbarMenu } from "./parts/view-menu";
import { ListToolbarTitle } from "./parts/view-title";

export type * from "./types-list-toolbar";
export { LIST_TOOLBAR_SEARCH_PLACEHOLDER } from "./messages";

/** Barra da listagem (`ListToolbar.Root/Title/Search/Filters/Actions/Menu`). */
export const ListToolbar = {
  Root: ListToolbarRoot,
  Title: ListToolbarTitle,
  Search: ListToolbarSearch,
  Filters: ListToolbarFilters,
  Actions: ListToolbarActions,
  Menu: ListToolbarMenu,
};
